export default "__VITE_ASSET__551888db__"